<template>
  <div class="rank">
    <my-table :infos="info" :titles="titles"></my-table>
  </div>
</template>

<script>
 import MyTable from '@/components/Table.vue'
 export default {
   name: '',
   props: {
   },
   data () {
     return {
       info: [],
     }
   },
   methods: {
     fetchData () {
       let round = this.$state.store.game_year + '-1';
       let area =  'NingXia';
       let uri = '/api/extra_rank?round='+round+'&area='+area;
       this.$http.get(uri)
           .then(res => {
             this.info = res.data.data.map(d=>
               {return [d.rank, d.username, this.remapExtra[d.area]]})
           })
     }
   },
   computed: {
     titles () {
       return ['排名', '姓名', '学校']
     },
     remapExtra() {
       return {
         'NingXia': '苏州'
       }
     }
   },
   mounted () {
     this.fetchData()
   },
   components: {
     MyTable
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .rank{
   margin-top: 20vw;
 }
</style>
